import * as React from 'react';
import { GroupedCardItem } from '@grandvisionhq/content';
import { Container, Heading } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { useBloomreachGroupCardsData } from '../../hooks/use-bloomreach-group-cards-data.js';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsGroupedCards = ()=>{
    const groupCardsData = useBloomreachGroupCardsData();
    if (!groupCardsData) return null;
    return /*#__PURE__*/ React.createElement(Container, {
        className: "group-cards",
        "data-t": "group-cards"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small"
    }, groupCardsData.title), groupCardsData.cards.map((item, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement(GroupedCardItem, {
            icon: item.icon,
            header: item.header,
            content: item.content,
            url: item.url,
            urlText: item.urlText
        }))
    ));
};
var GroupedCards = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsGroupedCards);

export { CmsGroupedCards, GroupedCards as default };
//# sourceMappingURL=GroupedCards.js.map
